const start = async function(elementId) {
    await setTimeout(async () => {
        var scrollFadeElement = document.getElementById(elementId);
        window.addEventListener('scroll', (e) => {
            fade(e, scrollFadeElement)
        });
    }, 50);
}

function percentage(partialValue, totalValue) {
    return (100 * partialValue) / totalValue;
}

//shared functions

var fade = function(_e, scrollFadeElement) {
    var scroll = window.pageYOffset || document.documentElement.scrollTop ||
        document.body.scrollTop || 0;
    scrollFadeElement.style.opacity = Math.max(0, Math.min(1, -scroll / 300 + 2));


    const maxScale = 3

    const fullSize = scrollFadeElement.offsetHeight;
    const currentSize = scroll;

    if (currentSize < fullSize) {
        var p = (100 * currentSize) / fullSize;

        var scrolled = (maxScale / 100) * p;


        var transformValue = scrolled *
            100;
        if (scrolled > 1) {
            scrollFadeElement.style.backgroundPosition = `center center`;
            scrollFadeElement.style.backgroundSize = `auto ${transformValue}%`;
        } else {
            scrollFadeElement.style.backgroundSize = `cover`;
        }


    }





}

const stop = async function(elementId) {
    var scrollFadeElement = document.getElementById(elementId);
    window.removeEventListener('scroll', (e) => {
        fade(e, scrollFadeElement)
    });
}


module.exports = {
    start: start,
    stop: stop
}
